import { graphql } from "gatsby"
import React, { useEffect } from "react"
import RecoveryContent from "../components/organisms/recovery-content/recovery-content"
import "../shared/assets/scss/layout.scss"
import Layout from "../shared/components/organisms/layout/layout"
import useMobileMode from "../shared/hooks/useMobileMode"
import SEO from "./../shared/components/seo"
// import FirstStepContent from "../components/organisms/first-step-content/first-step-content"
import "./../shared/_shared/Index.scss"

const PasswordRecovery = props => {
    const { isMobile } = useMobileMode()

    const validateFakeSession = () => {
        if (localStorage.getItem('userData') && !localStorage.getItem('tokenData')) {
            localStorage.removeItem('userData')
            window.location.reload()
        }
    }

    useEffect(() => {
        validateFakeSession()
    }, [])

    const registerContent = props.data.allContentfulTenaRegistroV2.nodes[0]
    return (
        <Layout title={registerContent.metaTitulo} isMobile={isMobile} isFullPage={true} btnReturn={registerContent.botonVolverAlInicio} btnReturnRedirection={registerContent.botonVolverAlInicioRedireccion} btnWhatsapp >
            <SEO
                title={registerContent.metaTitulo}
                description={registerContent.metaDescripcion.metaDescripcion}
                lang={registerContent.lang}
            />
            <RecoveryContent content={registerContent} isMobile={isMobile} />

        </Layout>
    )
}

export const query = graphql`
  query PASS_RECOVERY($language: String!) {
    allContentfulTenaRegistroV2(filter: {node_locale: {eq: "es-CO"}, titulo: {eq: "Inicio de Sesión"}}) {
      nodes {
        metaTitulo
        metaDescripcion {
          metaDescripcion
        }
        titulo
        slug
        banner {
          description
          fluid(maxWidth: 1080, quality: 100) {
            src
            srcSet
            base64
            aspectRatio
            sizes
          }
        }
        botonAtras
        informacionPrincipal {
          json
        }
        inputCorreoYCelular
        inputContrasena
        informacionSecundaria {
          json
        }
        botonIniciarSesion
        botonSiguiente
        botonVolverAlInicio
        botonVolverAlInicioRedireccion
      }
    }
    allContentfulTenaPaises(filter: { node_locale: { eq: $language } }) {
      nodes {
        codigoDeDosLetras
        codigoDelPais
        lenguaje
        titulo
        dominio
        prefijoTelefonico
      }
    }
  }
`;

export default PasswordRecovery;